export default __webpack_public_path__ + "static/media/recover_data.4f213435.png";